import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import { app } from "./lib/app";
import locale from "element-ui/lib/locale/lang/vi";
import { HTTP } from "./lib/http-common";
import IconV2 from "./components/common/IconV2.vue";

Vue.component("IconV2", IconV2);

import excel from "vue-excel-export";

Vue.use(excel);
import VueSlideBar from "vue-slide-bar";

Vue.component("VueSlideBar", VueSlideBar);

Vue.prototype.$http = HTTP;
Vue.config.productionTip = false;

import ElementUI from "element-ui";
import "./style/scss/app.scss";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEyeSlash,
  faReplyAll,
  faFileInvoice,
  faTags,
  faHome,
  faCalendar,
  faWindowClose,
  faReceipt,
  faSmile,
  faImages,
  faCommentAlt,
  faPaperPlane,
  faFolder,
  faFolderOpen,
  faPaperclip,
  faStoreAlt,
  faComments,
  faCommentSlash,
  faFileInvoiceDollar,
  faBox,
  faTag
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueSkeletonLoader from "skeleton-loader-vue";
import ScrollLoader from "vue-scroll-loader";
import VueNativeNotification from "vue-native-notification";
import VueTour from "vue-tour";

import vueDebounce from "vue-debounce";
import moment from "moment";

Vue.prototype.moment = moment;

import VueGtag from "vue-gtag";

import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueSkeletonLoader);


Vue.use(VueGtag, {
  config: { id: "G-0XDYQXM76X" },
  params: {
    send_page_view: false
  }
});

Vue.use(vueDebounce, {
  listenTo: ["input", "keyup"]
});


require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
});

library.add(
  faEyeSlash,
  faReplyAll,
  faFileInvoice,
  faTags,
  faHome,
  faCalendar,
  faWindowClose,
  faReceipt,
  faSmile,
  faImages,
  faCommentAlt,
  faPaperPlane,
  faFolder,
  faFolderOpen,
  faPaperclip,
  faStoreAlt,
  faComments,
  faCommentSlash,
  faFileInvoiceDollar,
  faBox,
  faTag
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(ScrollLoader);
Vue.use(ElementUI, { locale });
Vue.filter("highlight", function (words, query) {
  if (words.length === 0) return "<span class=\"\">" + "(Không có tiêu đề)" + "</span>";
  return words.replace(query, "<span class=\"zalo-highlight\">" + query + "</span>");
});
Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        // here I check that click was outside the el and his children
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

const store = new Vuex.Store({
  state: {
    accounts: [],
    stickerPacks: [],
    stickerIcons: {}
  },
  mutations: {
    updateAccounts(state, accounts) {
      state.accounts = accounts;
    },
    updateStickerPacks(state, packs) {
      state.stickerPacks = packs;
    },
    updateStickerIcons(state, pack) {
      state.stickerIcons[pack.packId] = pack.icons;
    }
  },
  actions: {}
});

import Socket from "@/lib/websocket";
import { COMMON } from "./lib/Common";
import Config from "./lib/Config";

const EventBus = new Vue();

Vue.mixin({
  data: () => ({
    app
  }),
  computed: {
    $bus() {
      return EventBus;
    }
  },

  methods: {
    // eslint-disable-next-line no-unused-vars
    removeMessageOriginal(message, messageList) {
      try {
        let action = JSON.parse(message.content).action;
        if ("todo.create" === action && !messageList.find(s => s.msgType === "chat.todo" && "todo.delete" === JSON.parse(s.content).action && JSON.parse(JSON.parse(s.content).params).item.id === JSON.parse(JSON.parse(message.content).params).item.id)) {
          let content = JSON.parse(message.content);
          let item = JSON.parse(content.params).item;
          let originalMessage = messageList.find(s => s.id.msgId === item.extra.msgId);
          if (originalMessage) {
            messageList.splice(messageList.indexOf(originalMessage), 1);
          }
        }
      } catch (e) {
        //
      }
    },
    convertToDoMessage(messageList) {
      try {
        let todoItems = messageList.filter(s => s.msgType === "chat.todo");
        let actionTodos = todoItems.filter(s => {
          if (s.msgType === "chat.todo") {
            let action = JSON.parse(s.content).action;
            return ["todo.update", "todo.ding", "todo.delete"].includes(action);
          }
        });
        for (let item of actionTodos) {
          this.handleTodoMessageAction(item, messageList);
        }
        let todoCreates = todoItems.filter(s => {
          let action = JSON.parse(s.content).action;
          return "todo.create" === action;
        });

        for (let todoCreate of todoCreates) {
          this.removeMessageOriginal(todoCreate, messageList);
        }
      } catch (e) {
        //
      }
    },
    // eslint-disable-next-line no-unused-vars
    getContentAction(content, accountId) {
      // console.log(content,accountId);
      // let updateData = {
      //   removeAssignees: ["431312220054975522"],
      //   extraInfos: {
      //     dueDate: "dueDate add",
      //     dingTimes: "3",
      //     description: "update",
      //     lastStatus: "-1",
      //     "status.update": "0"
      //   }
      // };
      try {
        let params = JSON.parse(JSON.parse(content).params);
        let nameTodo = params.item.description;
        try {
          if (Object.keys(params.updateData).length > 0) {
            let updateData = params.updateData;
            if (updateData["removeAssignees"]) {
              if (updateData["removeAssignees"].length === 1 && params.editor === updateData["removeAssignees"][0]) {
                return " đã từ chối công việc : ' " + nameTodo + " '";
              } else {
                return " đã cập nhật lại danh sách nhận việc:' " + nameTodo + " '";
              }
            }
            if (updateData.dueDate) {
              return " đã cập nhật lại thời hạn: ' " + nameTodo + " '";
            }
            let extraInfos = updateData.extraInfos;
            if (extraInfos) {
              if (extraInfos.dingTimes) {
                return " nhắc nhở cập nhật tiến độ công việc lần thứ " + updateData.extraInfos.dingTimes + " : ' " + nameTodo + " '";
              }
              if (extraInfos.description) {
                return " đã thay đổi  tiêu đề công việc : ' " + nameTodo + " '";
              }
              if (extraInfos["status.update"]) {
                if (extraInfos["status.update"] == "0") {
                  return " đã nhận công việc : ' " + nameTodo + " '";
                }
                if (extraInfos["status.update"] == "1") {
                  return " đã hoàn thành công việc : ' " + nameTodo + " '";
                }
              }
            }
            return " cập nhật  công việc: ' " + nameTodo + " '";
          }

          let action = JSON.parse(content).action;
          if (action === "todo.delete") {
            return " đã xoá công việc: ' " + nameTodo + " '";
          } else if ("todo.ding_ack" === action) {
            return "Người dùng đã nhận nhắc nhở từ bạn : " + nameTodo;
          }
          return " cập nhật  công việc: ' " + nameTodo + " '";

        } catch (e) {

          return "  cập nhật  công việc: ' " + nameTodo + " '";
        }
      } catch (e) {
        //
      }
    },
    handleTodoMessageFromWebhook(message, messageList) {
      try {
        if (message.msgType === "chat.todo") {
          if (["todo.update", "todo.ding", "todo.delete"].includes(JSON.parse(message.content).action)) {
            this.handleTodoMessageAction(message, messageList);
          }
        }
        this.removeMessageOriginal(message, messageList);

      } catch (e) {
        //
      }
    },
    handleTodoMessageAction(message, messageList) {
      try {
        let content = JSON.parse(message.content);
        let item = JSON.parse(content.params).item;
        let id = item.id;
        let todos = messageList.filter(s => s.msgType === "chat.todo");
        let todoCreate = todos.find(s => JSON.parse(s.content).action === "todo.create" && JSON.parse(JSON.parse(s.content).params).item.id === id);
        if (todoCreate) {
          let index = messageList.indexOf(todoCreate);
          if (index !== -1) {
            if ("todo.delete" === content.action) {
              messageList.splice(index, 1);
            } else {
              let beforeTs = todoCreate.ts;
              if (Number(beforeTs) < Number(message.ts)) {
                let content = JSON.parse(message.content);
                let id = JSON.parse(JSON.stringify(todoCreate.id));
                content.action = "todo.create";
                todoCreate = JSON.parse(JSON.stringify(message));
                todoCreate.id = id;
                todoCreate.ts = beforeTs;
                todoCreate.content = JSON.stringify(content);
                messageList.splice(index, 1, todoCreate);
              }
            }
          }
        }
      } catch (e) {
        //
      }
    },
    hasErrorSendFile(file) {
      let maxFile = 200;
      if (file.size / 1000000 > maxFile) {
        this.alertError("Kích thước " + file.name + " lớn hơn " + maxFile + "MB");
        return true;
      }
      return false;
    },

    getAlias() {
      this.$http.get("/api/contact/alias").then(resp => {
        this.app.aliases.push(...resp.data);
      });
    },
    unread(conversationId) {
      this.$http.get("/api/conversation/unread", { params: { conversationId: conversationId } });
    },
    setRead(conversationId) {
      this.$http.get("/api/conversation/read", { params: { conversationId: conversationId } });
    },
    fetchAccountList() {
      return this.$http.get("/api/account/getAll").then(async resp => {
        this.app.accounts = resp.data;
        this.app.accounts.forEach(s => {
          this.app.aliases.push({ accountId: s.accountId, id: "-1", avatar: "", name: "All" });
        });
        await this.initWebsocket(resp.data);
        this.fetchPinConversation();
        return resp.data;
      });
    },
    getUrlImage(image) {
      let HOST = "";
      if (Config.DEV) {
        HOST = Config.HOST;
      } else {
        HOST = "https://zalo.salework.net";
      }
      return HOST + "/api/image/" + image;
    },
    async initWebsocket(accounts) {
      if (Socket.isConnected) Socket.disconnect();
      await this.fetchAllTags();
      Socket.requestConnect(stompClient => {
        stompClient.subscribe("/session/" + this.app.sessionId, frame => {
          try {
            let body = JSON.parse(frame.body);
            console.log(body);
            if (body.type == "ReplaceLinkEvent") {
              let data = body;
              let filter = app.replaceLink.filter((p) => p.msgId == data.msgId && p.conversationId == data.conversationId);
              if (filter == null || filter.length == 0) {
                data.link = data.link + "?cToken=" + localStorage.getItem("cToken");
                app.replaceLink.push(data);
                this.$bus.$emit("ReplaceLinkEvent", body);
              }
            } else if (body.event == "sendByList") {
              body.sendByList.forEach(s => {
                let data = s.data
                let filter = app.sendByList.filter((p) => p.msgId == data.msgId && p.toId == data.toId);
                if (filter == null || filter.length == 0) {
                  data.accountId = body.accountId;
                  app.sendByList.push(data);
                }
              })
              this.$bus.$emit("sendByListEvent", body);
            } else if (body.event == "zaloReactionList") {
              body.reactionList.forEach(item => {
                const isRemove = item.content.type == -1

                let reactionData = app.reactionList.find((r) => r.cliMsgId == item.cliMsgId);
                if (!reactionData) {
                  app.reactionList.push({
                    conversationId: item.conversationId,
                    cliMsgId: item.cliMsgId,
                    accountId: item.accountId,
                    idTo: item.info.idTo,
                    infoList: isRemove ? [] : [{ ...item.info, content: JSON.parse(item.info.content) }],
                    infoRemoveList: isRemove ? [item.info] : []
                  });
                } else {
                  if (isRemove) {
                    let removeData = reactionData.infoRemoveList.find(i => i.actionId === item.info.actionId)
                    if (!removeData) {
                      reactionData.infoRemoveList.push(item.info)
                      reactionData.infoList = reactionData.infoList.filter(r => (r.uidFrom == item.info.uidFrom && Number(r.ts) > Number(JSON.parse(item.info.ts))) || r.uidFrom != item.info.uidFrom)
                    }
                  } else {
                    const isNotValidReact = reactionData.infoRemoveList.find(r => Number(r.ts) > Number(JSON.parse(item.info.ts)) && r.uidFrom == item.info.uidFrom)
                    let reactionInfoData = reactionData.infoList.find(i => i.actionId === item.info.actionId)
                    if (!reactionInfoData && !isNotValidReact) {
                      reactionData.infoList.push({ ...item.info, content: JSON.parse(item.info.content) })
                    }
                  }
                }
              })
              this.$bus.$emit("zaloReactionList", body);
            } else if (body.statisticType == "Statistical_overview") {
              this.$bus.$emit("overview_event", body);
            } else if (body.statisticType == "Statistical_conversation") {
              this.$bus.$emit("ConversationStatistical_event", body);
            } else if (body.type == "ConversationStatistical_unreadAndNotReply") {
              this.$bus.$emit("ConversationStatistical_unreadAndNotReply_event", body);
            } else if (body.statisticType == "Statistical_employee") {
              this.$bus.$emit("EmployeeStatistical_event", body);
            } else if (body.statisticType == "Statistical_tag") {
              this.$bus.$emit("TagStatistical_event", body);
            } else if (body.event == "ContactExport") {
              this.$bus.$emit("ContactExport", body);
            } else if (body.event == "ConversationIdSuccess") {
              this.$bus.$emit("ConversationIdSuccess", body);
            } else if (body.event == "ConversationExport") {
              this.$bus.$emit("ConversationExport", body);
            } else if (body.event == "profileInfo") {
              this.$bus.$emit("profileInfo", body)
            } else if (body.event == "friendStatus") {
              this.$bus.$emit("friendStatus", body)
            } else if (body.event == "onlineStatus") {
              this.$bus.$emit("onlineStatus", body)
            } else if (body.event == "pinList") {
              this.$bus.$emit("pinList", body)
            } else if (body.event == "filterMessageTab") {
              this.$bus.$emit("filterMessageTab", body)
            } else if (body.event == 'SearchMessageDto') {
              this.$bus.$emit("SearchMessageDto", body)
            } else if (body.event == 'SearchMessageInnerDto') {
              this.$bus.$emit("SearchMessageInnerDto", body)
            } else if (body.event == 'EmployeeStatistical_friendRequest') {
              this.$bus.$emit("EmployeeStatistical_friendRequest", body)
            } else if (body.event == "AccountIdSuccess") {
              this.$bus.$emit("AccountIdSuccess", body);
            }
          } catch (e) {
            //
          }
        });

        stompClient.subscribe("/user/" + this.app.user.swUsername, frame => {
          try {
            console.log(frame.body);
            let body = JSON.parse(frame.body);
            if (body.event === "logoutUser") {
              window.location.reload();
            }
          } catch (e) {
            //
          }
        });
        for (const shop of accounts) {
          stompClient.subscribe("/chat/" + shop.accountId, frame => {
            try {
              let body = JSON.parse(frame.body);
              console.log(body);
              if (body.event == "read") {
                this.$bus.$emit("conversationRead", body.conversation);
              } else if (body.event == "sendBy") {
                let data = body.data;
                let filter = app.sendByList.filter((p) => p.msgId == data.msgId && p.toId == data.toId);
                if (filter == null || filter.length == 0) {
                  data.accountId = body.accountId;
                  app.sendByList.push(data);
                  this.$bus.$emit("sendByEvent", data);
                }
              } else if (body.event == "zaloReaction") {
                const isRemove = body.content.type == -1

                let reactionData = app.reactionList.find((r) => r.cliMsgId == body.cliMsgId);
                if (!reactionData) {
                  app.reactionList.push({
                    conversationId: body.conversationId,
                    cliMsgId: body.cliMsgId,
                    accountId: body.accountId,
                    idTo: body.info.idTo,
                    infoList: isRemove ? [] : [{ ...body.info, content: JSON.parse(body.info.content) }],
                    infoRemoveList: isRemove ? [body.info] : []
                  });
                } else {
                  if (isRemove) {
                    let removeData = reactionData.infoRemoveList.find(i => i.actionId === body.info.actionId)
                    if (!removeData) {
                      reactionData.infoRemoveList.push(body.info)
                      reactionData.infoList = reactionData.infoList.filter(r => (r.uidFrom == body.info.uidFrom && Number(r.ts) > Number(JSON.parse(body.info.ts))) || r.uidFrom != body.info.uidFrom)
                    }
                  } else {
                    const isNotValidReact = reactionData.infoRemoveList.find(r => Number(r.ts) > Number(JSON.parse(body.info.ts)) && r.uidFrom == body.info.uidFrom)
                    let reactionInfoData = reactionData.infoList.find(i => i.actionId === body.info.actionId)
                    if (!reactionInfoData && !isNotValidReact) {
                      reactionData.infoList.push({ ...body.info, content: JSON.parse(body.info.content) })
                    }
                  }
                }
                this.$bus.$emit("zaloReaction", body);
              } else if (body.event == "typing") {
                let data = body.data;
                if (data.username == this.app.user.swUsername) return;
                this.$bus.$emit("conversationTyping", data);
              } else if (body.event == "hidden_conversation") {
                let conversationId = body.conversation_id;
                this.$bus.$emit("hidden_conversation", conversationId);
              } else if (body.event == "conversation_tag") {
                let data = body.data;
                this.$bus.$emit("conversation_tag", data);
              } else if (body.event == "eventGetCommonGroup") {
                this.$bus.$emit("eventGetCommonGroup", body);
              } else if (body.event == "updateGrMessage") {
                this.$bus.$emit("updateGrMessage", body.data);
              } else if (body.event == "renew_link") {
                this.$bus.$emit("RenewLinkEvent", body);
              } else if (body.event == "addNewMessage") {
                this.$bus.$emit("messageUpdate", body.message);
                this.$bus.$emit("currentConversationUpdate", body.message);
              } else {
                let push = false;
                if (!this.isUserTypeAdmin()) {
                  let tags = body.conversation.tags.filter(t => t.status == "ACTIVE");
                  tags.forEach((tag) => {
                    let s = this.app.tagAssignMe.filter((f) => f.id == tag.id);
                    if (s && s.length > 0) {
                      push = true;
                    }
                  });
                  if (!push) {
                    let assign = false;
                    tags.forEach((tag) => {
                      let s = this.app.tagAssign.filter((f) => f.id == tag.id);
                      if (s && s.length > 0) {
                        assign = true;
                      }
                    });
                    if (!assign && this.app.showAllContact) {
                      push = true;
                    }
                  }
                } else {
                  push = true;
                }
                if (push) {
                  if (body.message) {
                    let message = body.message;
                    this.$bus.$emit("messageUpdate", message);
                  }
                  if (body.conversation) {
                    if (this.isUserTypeAdmin() || !body.conversation.hidden) {
                      this.$bus.$emit("conversationUpdate", body.conversation);
                      if (body.message && body.conversation.unreadCount > 0 && body.conversation.pushNotify && Number(body.message.ts) > this.app.logInAt) {
                        this.notifyMe(this.lastConversationType(body.conversation.lastContent, body.conversation.lastMessageContent, body.conversation.lastMessageType));
                      }
                    }
                  }
                }
              }
            } catch (e) {
              //
            }
          });
        }
      });
    },

    updateDraftMessage(id, message) {
      let request = {
        id: { conversationId: id },
        username: this.app.user.swUsername,
        content: message,
        type: COMMON.WEBCHAT
      };
      this.$http.post("/api/message/updateDraft", request).then(resp => {
        let data = resp.data;
        if (request.content.length > 0) {
          this.$set(this.app.draftMessageList, data.id.conversationId, data);
        } else {
          this.$delete(this.app.draftMessageList, data.id.conversationId);
        }
        this.$bus.$emit("actionDraftMessage", data.id.conversationId);
      }).catch(() => {
        this.$delete(this.app.draftMessageList, id);
      });
    },
    handleDraftMessage(message, id) {
      if (message.trim().length === 0 && !this.app.draftMessageList[id]) return;
      this.updateDraftMessage(id, message);
    },
    getDraftMessageHistory(id) {
      if (this.app.draftMessageList[id]) {
        return this.app.draftMessageList[this.conversation.id].content;
      } else {
        return "";
      }
    },
    getDraftMessage() {
      this.$http.get("/api/message/draft", { params: { swUsername: this.app.user.swUsername } }).then(resp => {
        let arr = resp.data;
        arr.forEach(s => {
          this.$set(this.app.draftMessageList, s.id.conversationId, s);
        });
      });
    },
    async fetchAllQuickReply() {
      let resp = await this.$http.get("/api/quickMessageConfig/allByCurrentUser");
      this.app.quickReplyList = resp.data;
    },
    async fetchAllTags() {
      let resp = await this.$http.get("/api/tag");
      this.app.tags = resp.data;
      if (this.isAdminUser() && this.app.tags.length == 0) {
        this.suggestTag = true;
      }

    },
    splitComma(item) {
      if (item) {
        return item.split(",");
      } else {
        return [];
      }
    },
    getUrl(path) {
      return `https://storage.googleapis.com/${this.app.user.companyCode}/${path}`;
    },
    dataLoaded() {
      this.$emit("dataLoaded");
    },
    formatNumber(number) {
      if (!number) return 0;
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    subString(text, length) {
      if (!text || text.length < length) return text;
      return text.substring(0, length) + "...";
    },
    alert(type, message) {
      if (type === "success") {
        this.$message({
          showClose: true,
          message: message,
          type: "success"
        });
      } else if (type === "error") {
        this.$message({
          showClose: true,
          message: message,
          type: "error"
        });
      }
    },
    getShopNameFirstLetter(shopId) {
      return this.$store.state.accounts.find(shop => shop.shopId === shopId).shopName[0];
    },
    getShopColor(shopId) {
      return this.$store.state.accounts.find(shop => shop.shopId === shopId).colorCode;
    },
    convertTime(time) {
      return moment(Date.parse(time)).format("YYYY-MM-DD hh:mm:ss");
    },
    convertTimeOrderDetail(time) {
      return moment(Date.parse(time)).format("hh:mm:ss DD/MM/YYYY");
    },
    formatCurrency(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " VNĐ";
    },
    printNumber(x) {
      x = Number(x);
      if (isNaN(x) || !isFinite(x)) return "";
      return String(Math.round(x * 100) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "đ";
    },

    setTransparencyHex(hex, opacity) {
      let color = hex.substring(1, hex.length);
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return "#" + color + _opacity.toString(16).toUpperCase();
    },

    async fetchOrdersByCustomer(shopId, toName) {
      return await HTTP.get("/api/stock/getOrderByCustomerId", {
        params: {
          shopId: shopId,
          customerCode: toName,
          code: ""
        }
      });
    },
    dropImage(imageBlob) {
      if (imageBlob) {
        // Crossbrowser support for URL
        var URLObj = window.URL || window.webkitURL;
        var url = URLObj.createObjectURL(imageBlob);
        var image = {
          file: imageBlob,
          url: url
        };
        if (this.app.selectedImages) this.app.selectedImages.push(image);
        else {
          this.app.selectedImages = [];
          this.app.selectedImages.push(image);
        }

      }
    },
    dropHandler(ev) {
      ev.preventDefault();
      if (ev.dataTransfer.items) {
        [...ev.dataTransfer.items].forEach((item) => {
          // if (item.type.includes("image")) {
          const file = item.getAsFile();
          this.dropImage(file);
          // }
        });
      } else {
        [...ev.dataTransfer.files].forEach((file) => {
          // if (file.type.includes("image")) {
          const blob = file.getAsFile();
          this.dropImage(blob);
          // }
        });
      }
    },

    filePickup(data) {
      [...data.files].forEach(file => {
        this.dropImage(file);
      });
    },

    isJsonString(content) {
      try {
        var json = JSON.parse(content);
        return (typeof json === "object");
      } catch (e) {
        return false;
      }
    },
    newTab(path) {
      window.open(path, "_blank");
    },
    getAllCharacterFilter() {
      this.$http.get("/api/characterFilter/all").then(resp => {
        this.app.characterFilters = resp.data;
      });
    },
    getAccountSetting() {
      this.$http.get("/api/account/setting/get").then(resp => {
        this.app.accountSetting = resp.data;
      });
    },
    alertError(message) {
      return this.alert("error", message);
    },
    isLinkMessage(message) {
      try {
        let a = message.msgType === "chat.recommended" && JSON.parse(message.content).action === "recommened.link";
        return a;
      } catch (e) {
        return false;
      }
    },
    isActionMessage(message) {
      try {

        let con = JSON.parse(message.content);
        return ["msginfo.actionlist"].includes(con.action) || ["todo.update", "todo.ding", "todo.delete", "todo.ding_ack"].includes(con.action);
      } catch (e) {
        return false;
      }
    },
    isAdminUser() {
      if (this.app.user.type == "ADMIN") return true;
      if (this.app.permissions.length > 0) {
        let per = this.app.permissions.filter(p => p.code === "ZALO_MANAGE");
        if (per && per.length > 0) {
          return true;
        }
      }
      return false;
    },
    isContactUser() {
      if (this.app.user.type == "ADMIN") return true;
      if (this.app.permissions.length > 0) {
        let per = this.app.permissions.filter(p => p.code === "ZALO_CONTACT");
        if (per && per.length > 0) {
          return true;
        }
      }
      return false;
    },
    isEmployeeManageUser() {
      if (this.app.user.type == "ADMIN") return true;
      if (this.app.permissions.length > 0) {
        let per = this.app.permissions.filter(p => p.code === "EMPLOYEE_ACCOUNT_MANAGE");
        if (per && per.length > 0) {
          return true;
        }
      }
      return false;
    },
    isUserTypeAdmin() {
      if (this.app.user.type == "ADMIN") return true;
      return false;
    },
    isShowListFriend() {
      if (this.app.user.type == "ADMIN") return true;
      return this.app.showListFriend
    },
    formatLastMessageTime(time) {
      let date = new Date(Number(time));
      let now = new Date();
      if (now.getDate() === date.getDate() && now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear())
        return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
      return this.formatDateTimeShort(Number(time));
    },
    formatDateTimeShort(time) {
      var date = new Date(time);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      return day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    },
    fileTypeIcon(type) {
      if (type == "docx") {
        type = "word";
      } else if (type == "mp4" || type == "m4a") {
        type = "video";
      }
      if (type.includes("vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        type = "xlsx";
      }
      let icon = {
        type: "file-empty",
        url: "https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg"
      };
      let filter = app.iconType.filter(p => type.includes(p.type));
      if (filter != null && filter.length > 0) {
        return filter[0].url;
      }
      return icon.url;
    },
    getFileSize(size) {
      if (size / 1024 > 1) {
        size = size / 1024;
        if (size / 1024 > 1) {
          size = size / 1024;
          if (size / 1024 > 1) {
            size = size / 1024;
            return size.toFixed(2) + " GB";
          }
          return size.toFixed(2) + " MB";
        }

        return size.toFixed(2) + " KB";
      }
      return size + " B";
    },
    handleAlias(messageList) {
      let mentionMessage = messageList.filter(s => s.mentions && s.mentions.length > 0);
      let mentionUids = new Set();

      mentionMessage.forEach(s => {
        let items = JSON.parse(s.mentions);
        items.forEach(s => {
          if (!this.app.aliases.find(a => s.uid === a.id && a.accountId === this.app.selectedConversation.accountId)) {
            if (s.uid !== this.app.selectedConversation.accountId) {
              mentionUids.add(s.uid);
            }
          }
        });
      });
      if (mentionUids.size === 0) return;
      this.getAliasV2(mentionUids);
    },
    getAliasV2(mentionUids) {

      this.$http.post("/api/contact/aliasV2?accountId=" + this.app.selectedConversation.accountId, Array.from(mentionUids)).then(resp => {
        this.app.aliases.push(...resp.data);
      });
    },


    getAllGroupId() {
      this.$http.get("/api/conversation/getAllGroupId").then(resp => {
        try {
          let array = resp.data;
          for (let i = 0; i < array.length; i++) {
            let item = JSON.parse(array[i]);
            if (item.error_code !== 0) continue;
            let gridVerMap = item.data.gridVerMap;
            let arrIds = [];
            for (let id in gridVerMap) {
              arrIds.push(id);
            }
            this.app.allGroupIds.set(item.accountId, arrIds);
          }
        } catch (e) {
          //
        }
      });
    },
    isPhotoGroup(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              return true;
            }
          }
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    isCanPin(message) {
      if (this.isPhotoGroup(message)) return false;

      if (this.isActionMessage(message)) return false;
      return [1, 32, 46].includes(this.getMsgType(message));
    },
    isCardBusiness(message) {
      try {
        return "recommened.user" === JSON.parse(message.content).action;
      } catch (e) {
        return false;
      }
    },
    getMsgType(message) {
      if (message.msgType === COMMON.WEBCHAT) {
        return 1;
      }
      if (message.msgType === COMMON.CHAT_PHOTO) {
        return 32;
      }
      if (message.msgType === COMMON.CHAT_FILE) {
        return 46;
      }
    },
    getMessageToPin(message) {
      if (message.msgType === COMMON.WEBCHAT) {
        return message.content;
      }
      if (message.msgType === COMMON.CHAT_PHOTO) {
        return this.findUrlHDIfExist(message);
      }
      if (message.msgType === COMMON.CHAT_FILE) {
        return JSON.parse(message).title;
      }
    },
    findUrlHDIfExist(item) {
      try {
        let linkHD = JSON.parse(JSON.parse(item.content).params).hd;
        if (linkHD) {
          return linkHD;
        } else {
          return item.href;
        }
      } catch (e) {
        return item.href;
      }
    },
    findUrlHDIfExistV2(content) {
      try {
        let linkHD = JSON.parse(JSON.parse(content).params).hd;
        if (linkHD) {
          return linkHD;
        } else {
          return JSON.parse(content).href;
        }
      } catch (e) {
        return JSON.parse(content).href;
      }
    },
    findUrlThumbExistV2(content) {
      try {
        let linkThumb = JSON.parse(content).thumb;
        if (linkThumb) {
          return linkThumb;
        } else {
          return JSON.parse(content).href;
        }
      } catch (e) {
        return JSON.parse(content).href;
      }
    },
    lastConversationType(lastContent, text, msgType) {
      if (lastContent !== null) return lastContent;

      if (!text) return "";
      switch (text) {
        case "chat.photo": {
          return "[Hình ảnh]";
        }
        case "chat.sticker": {
          return "[Nhãn dán]";
        }
        case "chat.doodle": {
          return "[Hình ảnh]";
        }
        case "chat.gif": {
          return "[Ảnh động]";
        }
        case "chat.location.new": {
          return "[Ví trí]";
        }
        case "chat.ecard": {
          return "[Nhắc hẹn]";
        }
        case "chat.undo": {
          return "Tin nhắn đã được thu hồi";
        }
        case "chat.delete": {
          return "Tin nhắn đã được xóa";
        }
        case "share.file": {
          return "Tệp tin";
        }
        case "group.poll": {
          return "Tham gia cuộc bình chọn";
        }
      }
      // case "chat.recommended" : {
      //   return "[Liên hệ]";
      // }

      if (msgType == "webchat") {
        if (!text.includes("action", "msginfo.actionlist") || !text.includes("action", "rtf")) return text;
        try {
          let response = text.match(/title":"(.*)/)[1];
          return response.split("params")[0].slice(0, -3);
        } catch (e) {
          return text;
        }
      }
      return msgType;
    },
    copyToClipboard(str, message) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", message);
    },
    notifyMe(message) {
      if (!window.Notification) {
        console.log("Browser does not support notifications.");
      } else {
        // check if permission is already granted
        if (Notification.permission === "granted") {
          // show notification here
          new Notification("Bạn có tin nhắn zalo mới!", {
            body: message,
            icon: "/favicon.ico"
          });
        } else {
          // request permission from user
          Notification.requestPermission()
            .then(function (p) {
              if (p === "granted") {
                // show notification here
                new Notification("Bạn có tin nhắn zalo mới!", {
                  body: message,
                  icon: "/favicon.ico"
                });
              } else {
                console.log("User blocked notifications.");
              }
            })
            .catch(function (err) {
              console.error(err);
            });
        }
      }
    },
    sendTypingSocket(type) {
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        type: type,
        username: this.app.user.swUsername
      };
      this.$http.post("/api/conversation/typing", request);
    },
    checkShopExpired() {
      this.app.zaloNotify = true;
      if (!localStorage.getItem("showTour") || this.app.paymentType === "PREPAYMENT" || localStorage.getItem("Notify15052023")) {
        this.app.zaloNotify = false;
      }
    },
    pushSelectImages(message) {
      this.app.selectedImages.push(...message.urls);
    },
    getIdFromUrl(item) {
      return item.substring(item.lastIndexOf("/") + 1, item.length);
    },
    fetchPinConversation() {
      return this.$http.get("/api/conversation/pin").then(resp => {
        this.app.pinConversationView = [];
        this.app.pinConversations = [];
        if (resp.data && this.app.accounts.length > 0) {
          resp.data.forEach((pin) => {
            this.app.pinConversations.push(pin);
            let p = this.app.accounts.filter(s => s.accountId == pin.accountId);
            if (p != null && p.length > 0) {
              let push = false;
              if (!this.isUserTypeAdmin()) {
                let tags = pin.tags;
                tags.forEach((tag) => {
                  let s = this.app.tagAssignMe.filter((f) => f.id == tag.id);
                  if (s && s.length > 0) {
                    push = true;
                  }
                });
                if (!push) {
                  let assign = false;
                  tags.forEach((tag) => {
                    let s = this.app.tagAssign.filter((f) => f.id == tag.id);
                    if (s && s.length > 0) {
                      assign = true;
                    }
                  });
                  if (!assign && this.app.showAllContact) {
                    push = true;
                  }
                }
              } else {
                push = true;
              }
              if (push) {
                pin.isPin = true;
                this.app.pinConversationView.push(pin);
              }
            }
          });
        }
      });
    },
    getAccountName(account) {
      let prefix = "";
      if (account.status !== "ACTIVE") {
        prefix = "(OFF)";
      }
      if (account.swName && account.swName.length > 0)
        return prefix + account.swName;
      return prefix + account.displayName;
    },
    subPhone(phone) {
      if (phone.startsWith("0")) {
        phone = "+84" + phone.substring(1);
      }
      if (phone.startsWith("84")) {
        phone = "+84" + phone.substring(2);
      }
      if (phone.startsWith("840")) {
        phone = "+84" + phone.substring(3);
      }
      if (phone.startsWith("+840")) {
        phone = "+84" + phone.substring(4);
      }
      return phone;
    },
    getStatus(item, accountId) {
      //  0 da nhan
      // -1 chua xong
      //  1 da hoan thanh
      let received = item.assignees.filter(s => s.status === 1);
      if (received.length > 0 && item.status !== 1) {
        if (item.assignees.find(s => s.status === 1 && s.userId === accountId)) {
          return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành" + "</span>";
        }

        let data = item.assignees.find(s => s.status === 1);
        if (data && item.assignees.length === 1) {
          return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành" + "</span>";
        }
        if (data && item.assignees.length > 1 && item.assignees.find(s => s.userId === item.creator && s.userId === accountId)) {
          let done = item.assignees.filter(s => s.status === 1).length;
          if (done > 0) {
            return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành" + " (" + done + "/" + item.assignees.length + ")" + "</span>";
          }
        }
      }

      if (item.status === -1) {
        let received = item.assignees.filter(s => s.status === 0);
        if (received.length > 0) {
          if (item.creator !== accountId && item.assignees.find(s => s.userId === accountId && s.status === -1)) {
            return "<span class=\"pointer mb-0 text-danger\">" + "Chưa nhận" + "</span>";
          }
          return "<span class=\"pointer mb-0 \">" + "Đã nhận" + " (" + received.length + "/" + item.assignees.length + ")" + "</span>";
        }
        return "<span class=\"pointer mb-0 text-danger\">" + "Chưa nhận" + "</span>";
      } else if (item.status === 1) {
        let done = item.assignees.filter(s => s.status === 1).length;
        if (done > 1) {
          return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành" + " (" + done + "/" + item.assignees.length + ")" + "</span>";
        }
        return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành" + "</span>";
      } else {
        let done = item.assignees.filter(s => s.status === 1).length;
        if (done > 0) {
          return "<span class=\"pointer mb-0 text-done\">" + "Đã hoàn thành " + " (" + done + "/" + item.assignees.length + ")" + "</span>";
        }
        return "Đã nhận";
      }

      // if (item.status === -1) {
      //
      //   return "<span class=\"pointer mb-0 text-blue\">" + "Chưa xong" + "</span>";
      // } else if (item.status === 1) {
      //   return "<span class=\"pointer mb-0 text-done\">" + "Đã xong" + "</span>";
      // } else {
      //   return "<span class=\"pointer mb-0 text-blue\">" + "Chưa xong" + "</span>";
      // }
    },
    openTodo(message, item) {
      item.message = message;
      this.app.isShowTodoDetail = true;
      this.app.todoItem = item;
    },
    getDetailDueDate(item) {
      let date = item.dueDate;
      if (item.dueDate === -1) {
        return "Không thời hạn";
      }
      return moment(date).format("DD/MM/YY HH:mm:ss");
    },
    acceptTask(item, accountId) {
      let req = {
        accountId: accountId,
        params: JSON.stringify({ id: item.id, status: 0 })
      };
      this.$http.post("/api/todo/status", req).then(s => {
        if (s.data.error_code === 0) {
          this.alert("success", "Nhận việc thành công");
          this.$bus.$emit("updateTask", item);
        } else {
          this.alertError(s.data.error_message);
        }
      });
    },
    ding(item, accountId) {
      let req = {
        accountId: accountId,
        params: JSON.stringify({ id: item.id })
      };

      this.$http.post("/api/todo/ding", req).then(s => {
        if (s.data.error_code === 0) {
          this.alert("success", "Nhắc nhở thành công");
        } else {
          this.alertError("Nhắc nhở công việc không thành công.");
          // this.alertError(s.data.error_message);
        }
      });

    },
    rejectTask(item, accountId) {
      let data = JSON.parse(JSON.stringify(item));
      data.status = -1;

      let req = {
        accountId: accountId,
        id: data.id,
        assignees: "[]",
        content: data.content,
        status: -1,
        schedule: "null",
        creator: data.creator,
        watchers: "[]",
        dateDefaultType: data.dateDefaultType,
        description: data.description,
        dueDate: data.dueDate,
        extra: JSON.stringify(data.extra)
      };
      if (item.assignees.length === 1) {
        req.assignees = "[]";
      } else {
        req.assignees = JSON.stringify(item.assignees.filter(s => s.userId !== accountId).map(s => s.userId));
      }
      this.$confirm("Xác nhận từ chối công việc .", "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(async () => {
        this.$http.post("/api/todo/reject", req).then(s => {
          if (s.data.error_code === 0) {
            this.app.isShowTodoDetail = false;
            this.alert("success", "Từ chối công việc thành công.");
            this.app.isShowTodoDetail = false;
            item.action = "reject";
            this.$bus.$emit("updateTask", item);
          } else {
            this.alertError("Từ chối công việc không thành công.");
            // this.alertError(s.data.error_message);
          }
        });
      });
    },
    isCreator(item) {
      return item.statusTodo === 0 || this.selectedAccount.accountId === item.creator;
    },
    isShowButtonRejectTodo(item, accountId) {
      return !this.isCreator(item) && item.status === -1 && item.assignees.find(s => [-1, 0].includes(s.status) && s.userId === accountId);
    },
    finishTask(item, accountId) {
      let req = {
        accountId: accountId,
        params: JSON.stringify({ id: item.id, status: 1 })
      };
      this.$confirm("Xác nhận hoàn thành công việc .", "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(async () => {
        this.$http.post("/api/todo/status", req).then(s => {
          if (s.data.error_code === 0) {
            this.alert("success", "Thao tác thành công");
            this.app.isShowTodoDetail = false;
            this.$bus.$emit("updateTask", item);
          } else {
            this.alertError("Hoàn thành công việc không thành công.");
            // this.alertError(s.data.error_message);
          }
        });
      });
    },
    getTitleTodoName(message) {
      let content = JSON.parse(message.content);
      let todoName = JSON.parse(content.params).item.description;
      if (content.action === "todo.update") {
        if (JSON.parse(content.params).item.status === 1) {
          return "Hoàn thành công việc " + todoName;
        }
        return "Cập nhật công việc " + todoName;
      } else if (content.action === "todo.ding") {
        return "Nhắc nhở công việc " + todoName;
      } else if (content.action === "todo.delete") {
        return "Công việc đã xoá " + todoName;
      }
      return "Công việc " + todoName;
    },
    getCloudData(conversationId, msgId) {
      let s = app.replaceLink.filter((l) => l.conversationId == conversationId && l.msgId == msgId);
      if (s != null && s.length > 0) {
        return s[0];
      }
      return null;
    },
    getCloudUrl(url, mes) {
      try {
        if (app.replaceLink.length > 0 && mes) {
          let filter = app.replaceLink.find((m) => m.msgId == mes.id.msgId);
          const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;
          const now = Date.now();
          if (filter && (now - mes.ts) >= FIFTEEN_DAYS_MS) {
            return filter.link;
          }
        }
      } catch (e) {
        return url
      }
      return url;
    },

    showMessage(message) {
      if (message.msgType === "webchat"

        || message.msgType == "chat.sticker"
        || message.msgType == "chat.doodle"
        || message.msgType == "chat.recommended"
        || message.msgType == "chat.gif"
        || message.msgType == "chat.location.new"
        || message.msgType == "chat.ecard"
        || message.msgType == "chat.voice"
        || message.msgType == "share.file"
        || message.msgType == "chat.video.msg"
        || message.msgType == "group.poll"
        || message.msgType == COMMON.LOADING_FILE
        || message.msgType == "chat.todo"
      )
        return true;
      return false;
    },

    checkDeleteMessage(message, messageList) {
      let rt = false;
      let undoList = messageList.filter(m => m.msgType == "chat.delete");
      if (undoList.length > 0 && this.message.cliMsgId) {
        undoList.forEach((un) => {
          if (un.msgType == "chat.delete") {
            let item = JSON.parse(un.content)[0];
            if (item.clientDelMsgId.toString() == message.cliMsgId.toString()) {
              rt = true;
            }
          }
        });
      }
      return rt;
    },
    getIdMessage(message) {
      let id = message.id.msgId;
      try {
        id += message.showMessage;
        id += message.checkDeleteMessage;
        id += message.checkUndoMessage;
        id += message.checkDeleteMessage;
        id += message.showPt;

        id += message.showPhotoContent;
        id += message.replaceUrl;
        id += message.sendBy;
        if (message.getPhotoList) {
          let le = 0;
          message.getPhotoList.forEach((p) => {
            le += p.url.length;
          });
          id += le;
        }
      } catch (ex) {
        //
      }
      return id;
    },
    parseMessage(message, type, undoList, filter) {
      if (type == "new") {
        message.showMessage = this.showMessage(message);
        message.checkDeleteMessage = false;
        message.checkUndoMessage = false;
        if (undoList.length > 0 && message.cliMsgId) {
          undoList.forEach((un) => {
            try {
              if (un.msgType == "chat.delete") {
                let item = JSON.parse(un.content)[0];
                if (item.clientDelMsgId.toString() == message.cliMsgId.toString()) {
                  message.checkDeleteMessage = true;
                  message.checkUndoMessage = true;
                }
              }
              if (un.msgType == "chat.undo") {
                let item = JSON.parse(un.content);
                if (item.cliMsgId.toString() == message.cliMsgId.toString()) {
                  message.checkUndoMessage = true;
                }
              }
            } catch (e) {
              //
            }
          });
        }
        message.showPt = this.showPhoto(message);
        let showPhotoContent = false;
        message.groupLayoutId = null;
        if (message.msgType == "chat.photo") {
          try {
            if (JSON.parse(message.content).params) {
              let params = JSON.parse(JSON.parse(message.content).params);
              if (params.is_group_layout) {
                message.groupLayoutId = params.group_layout_id;
                if (params.id_in_group === 0) {
                  showPhotoContent = true;
                } else {
                  let id = JSON.parse(JSON.parse(message.content).params).group_layout_id;
                  let id_in_group = JSON.parse(JSON.parse(message.content).params).id_in_group;

                  let idsInGroup = this.messageList.filter(c => {
                    if (c.msgType === "chat.photo") {
                      let params = JSON.parse(JSON.parse(c.content).params);
                      if (params.group_layout_id) {
                        showPhotoContent = params.group_layout_id === id;
                      }
                    }
                    showPhotoContent = false;
                  }).map(s => JSON.parse(JSON.parse(s.content).params).id_in_group);
                  if (id_in_group === Math.min(...idsInGroup)) {
                    showPhotoContent = true;
                  } else {
                    showPhotoContent = false;
                  }
                }
              } else showPhotoContent = true;
            }
          } catch (e) {
            //
          }
          showPhotoContent = true;
        }
        if (message.groupLayoutId != null) {
          let photos = [];

          filter.forEach(item => {
            try {
              if (JSON.parse(message.content).params) {
                let params = JSON.parse(JSON.parse(item.content).params);
                if (params.is_group_layout) {
                  if (params.group_layout_id == message.groupLayoutId) {
                    const it = item;
                    let p = {
                      id: params.id_in_group,
                      url: this.getCloudUrl(this.findUrlHDIfExist(it.content), it),
                      globalMes: item
                    };
                    photos.push(p);
                  }
                }
              }
            } catch (e) {
              //
            }
          });
          message.getPhotoList = photos.sort((a, b) => b.id - a.id);
        }
        message.showPhotoContent = showPhotoContent;
        if (message.isActionMessage == undefined) {
          message.isActionMessage = this.isActionMessage(message);
          message.isShowThreeDot = !message.isActionMessage && message.msgType !== "chat.undo" && message.msgType !== "chat.delete";
          message.isShowDelete = !message.isActionMessage && message.msgType !== "chat.undo" && message.msgType !== "chat.delete";
          let isPhotoGroup = this.isPhotoGroup(message);
          let isCardBusiness = this.isCardBusiness(message);
          let isLinkMessage = this.isLinkMessage(message);
          message.isShowUndoIcon = !isPhotoGroup && message.cliMsgId != null && !message.isActionMessage && message.id.uidFrom === "0";
          message.isShowListIcon = (message.msgType === "webchat" || isLinkMessage || message.msgType === "chat.photo" || message.msgType === COMMON.CHAT_VIDEO || message.msgType === COMMON.CHAT_FILE || isCardBusiness && message.cliMsgId != null) && !message.isActionMessage;
          message.isShowMessageSharePopup = message.isShowListIcon && (message.msgType === "webchat" || message.msgType === "chat.photo" || message.msgType === COMMON.CHAT_VIDEO || isCardBusiness || message.msgType === COMMON.CHAT_FILE);
          message.isShowReplyIcon = message.isShowListIcon && (message.msgType === "webchat" || isLinkMessage || message.msgType === "chat.photo" && message.cliMsgId != null && isPhotoGroup === false);

          if (isPhotoGroup) message.isCanPin = false;

          if (message.isActionMessage) message.isCanPin = false;
          else message.isCanPin = [1, 32, 46].includes(this.getMsgType(message));
        }
      }
      try {
        if (message.replaceUrl == undefined) {
          let filter = app.replaceLink.filter((mes) => mes.msgId == message.id.msgId);
          if (filter != null && filter.length > 0) {
            message.replaceUrl = filter[0].link;
          }
        }
      } catch (e) {
        //
      }
      try {
        if (message.sendBy == undefined) {
          let filter = app.sendByList.filter((mes) => mes.msgId == message.id.msgId);
          if (filter != null && filter.length > 0) {
            message.sendBy = filter[0].username;
          }
        }
      } catch (ex) {
        // Ignore
      }
      message.newIdMessage = this.getIdMessage(message);
      return message;
    },
    parseMessageV2(message, type, undoList, filter) {
      if (message.type === "timeline") return message;
      if (type == "new") {
        message.showMessage = this.showMessage(message);
        message.checkDeleteMessage = false;
        message.checkUndoMessage = false;
        if (undoList.length > 0 && message.cliMsgId) {
          undoList.forEach((un) => {
            try {
              if (un.msgType == "chat.delete") {
                let item = JSON.parse(un.content)[0];
                if (item.clientDelMsgId.toString() == message.cliMsgId.toString()) {
                  message.checkDeleteMessage = true;
                  message.checkUndoMessage = true;
                }
              }
              if (un.msgType == "chat.undo") {
                let item = JSON.parse(un.content);
                if (item.cliMsgId.toString() == message.cliMsgId.toString()) {
                  message.checkUndoMessage = true;
                }
              }
            } catch (e) {
              //
            }
          });
        }
        message.showPt = this.showPhoto(message);
        let showPhotoContent = false;
        message.groupLayoutId = null;
        if (message.msgType == "chat.photo") {
          try {
            if (JSON.parse(message.content).params) {
              let params = JSON.parse(JSON.parse(message.content).params);
              if (params.is_group_layout) {
                message.groupLayoutId = params.group_layout_id;
                if (params.id_in_group === 0) {
                  showPhotoContent = true;
                } else {
                  let id = JSON.parse(JSON.parse(message.content).params).group_layout_id;
                  let id_in_group = JSON.parse(JSON.parse(message.content).params).id_in_group;

                  let idsInGroup = this.messageList.filter(c => {
                    if (c.msgType === "chat.photo") {
                      let params = JSON.parse(JSON.parse(c.content).params);
                      if (params.group_layout_id) {
                        showPhotoContent = params.group_layout_id === id;
                      }
                    }
                    showPhotoContent = false;
                  }).map(s => JSON.parse(JSON.parse(s.content).params).id_in_group);
                  if (id_in_group === Math.min(...idsInGroup)) {
                    showPhotoContent = true;
                  } else {
                    showPhotoContent = false;
                  }
                }
              } else showPhotoContent = true;
            }
          } catch (e) {
            //
          }
          showPhotoContent = true;
        }
        if (message.groupLayoutId != null) {
          let photos = [];

          filter.forEach(item => {
            try {
              if (JSON.parse(message.content).params) {
                let params = JSON.parse(JSON.parse(item.content).params);
                if (params.is_group_layout) {
                  if (params.group_layout_id == message.groupLayoutId && Math.abs(Number(message.ts) - Number(item.ts)) < 3 * 60 * 1000) {
                    const exist = photos.find(i => i.id === params.id_in_group)
                    if (!exist) {
                      photos.push({
                        id: params.id_in_group,
                        url: this.getCloudUrl(this.findUrlHDIfExistV2(item.content), item),
                        thumb: this.findUrlThumbExistV2(item.content),
                        globalMes: item
                      });
                    }

                  }
                }
              }
            } catch (e) {
              //
            }
          });
          message.getPhotoList = photos.sort((a, b) => b.id - a.id);
        }
        message.showPhotoContent = showPhotoContent;
        if (message.isActionMessage == undefined) {
          message.isActionMessage = this.isActionMessage(message);
          message.isShowThreeDot = !message.isActionMessage && message.msgType !== "chat.undo" && message.msgType !== "chat.delete";
          message.isShowDelete = !message.isActionMessage && message.msgType !== "chat.undo" && message.msgType !== "chat.delete";
          let isPhotoGroup = this.isPhotoGroup(message);
          let isCardBusiness = this.isCardBusiness(message);
          let isLinkMessage = this.isLinkMessage(message);
          message.isShowUndoIcon = !isPhotoGroup && message.cliMsgId != null && !message.isActionMessage && message.id.uidFrom === "0";
          message.isShowListIcon = (message.msgType === "webchat" || isLinkMessage || message.msgType === "chat.photo" || message.msgType === COMMON.CHAT_VIDEO || message.msgType === COMMON.CHAT_FILE || isCardBusiness && message.cliMsgId != null) && !message.isActionMessage;
          message.isShowMessageSharePopup = message.isShowListIcon && (message.msgType === "webchat" || message.msgType === "chat.photo" || message.msgType === COMMON.CHAT_VIDEO || isCardBusiness || message.msgType === COMMON.CHAT_FILE);
          message.isShowReplyIcon = message.isShowListIcon && (message.msgType === "webchat" || isLinkMessage || message.msgType === "chat.photo" && message.cliMsgId != null && isPhotoGroup === false);

          if (isPhotoGroup) message.isCanPin = false;

          if (message.isActionMessage) message.isCanPin = false;
          else message.isCanPin = [1, 32, 46].includes(this.getMsgType(message));
        }
      }
      try {
        if (message.replaceUrl == undefined) {
          let filter = app.replaceLink.filter((mes) => mes.msgId == message.id.msgId);
          if (filter != null && filter.length > 0) {
            message.replaceUrl = filter[0].link;
          }
        }
      } catch (e) {
        //
      }
      try {
        if (!message.sendBy) {
          let filter = app.sendByList.filter((mes) => mes.msgId == message.id.msgId);
          if (filter != null && filter.length > 0) {
            message.sendBy = filter[0].username;
          }
        }
      } catch (ex) {
        // Ignore
      }
      try {
        let reactionData = app.reactionList.find(r => r.cliMsgId === message.cliMsgId)
        if (reactionData) {
          message.reactions = [...reactionData.infoList]
        }
      } catch (ex) {
        // Ignore
      }
      message.newIdMessage = this.getIdMessage(message);
      return { ...message };
    },
    parseMessageEvent(message, type) {
      if (type === 'sendByList' || type === 'sendBy') {
        try {
          if (!message.sendBy) {
            let filter = app.sendByList.find((mes) => mes.msgId == message.id.msgId);
            if (filter) {
              message.sendBy = filter.username;
            }
          }
        } catch (ex) {
          // Ignore
        }
      }
      if (type === 'reactionList' || type === 'reaction') {
        try {
          let reactionData = app.reactionList.find(r => r.cliMsgId === message.cliMsgId)
          if (reactionData) {
            message.reactions = [...reactionData.infoList]
          }
        } catch (ex) {
          // Ignore
        }
      }
      return { ...message };
    },
    filterCharacter(conversation, message, filterCharacterArr) {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter((p) => p.accountId == conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = message;
        let arr = text.split(" ");
        if (filterCharacterArr && filterCharacterArr.length > 0 && arr.length > 0) {
          for (let item of filterCharacterArr) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    downSetup(data, fileName = "downloaded_file") {
      try {
        if (typeof data === "string") {
          fetch(data)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.blob();
            })
            .then((blob) => {
              this.createElementDownload(blob, fileName);
            })
            .catch((error) => {
              console.error("Download failed:", error);
            });
        } else {
          const blob = new Blob([data]);
          this.createElementDownload(blob, fileName);
        }
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    createElementDownload(data, fileName) {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }
});

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount("#app");
